<template>
  <footer class="app-footer" role="contentinfo">
    <div class="app-footer__inner">
      <p class="app-footer__text">© 2026 Fairfield City Council</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style src="./footer.css"></style>
